var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConventionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13455_161522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.15868 3.64258H0.743164V26.2809H6.15868V3.64258Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46973 3.4043H5.50082",
    stroke: "#282D33",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 19.7441H6.18705",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 25.873H6.18705",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 21.7871H2.59706",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 23.8301H2.59706",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41504 21.7871H6.23378",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41504 23.8301H6.23378",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.77832 26.5527L3.50643 31.3187L6.23455 26.5527",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46973 4.08492V2.04237C1.46973 1.29343 2.0805 0.680664 2.827 0.680664H4.18427C4.93077 0.680664 5.54154 1.29343 5.54154 2.04237V4.08492",
    fill: "#9AC7F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46973 4.08492V2.04237C1.46973 1.29343 2.0805 0.680664 2.827 0.680664H4.18427C4.93077 0.680664 5.54154 1.29343 5.54154 2.04237V4.08492",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2588 28.5956H15.722L11.6502 31.319V28.5956H9.61426V0.680664H27.2588V28.5956Z",
    fill: "#EAF4FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 4.76562H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 7.48926H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 10.2129H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 18.3828H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 21.1064H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.863 23.8301H13.0049",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.04 14.2979H16.3973",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7549 14.2979H19.1122",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4697 14.2979H21.827",
    stroke: "#9AC7F7",
    strokeWidth: 1.82857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46582 32.0006V29.958",
    stroke: "#0561FC",
    strokeWidth: 1.82857
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13455_161522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.5143,
    height: 32,
    fill: "white",
    transform: "translate(0.743164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConventionIcon);
export default __webpack_public_path__ + "static/media/convention-icon.8b8f57fbf1a5d73f8d677d2c0f8cba1e.svg";
export { ForwardRef as ReactComponent };